import { useEffect, useState } from "react";
import { api, formatApiError } from "./api";

const cache = {};

export function fetchPortfolioFeature(key = "anon", force = false) {
  if (!cache[key] || force) {
    cache[key] = api
      .get("/admin/portfolio-feature")
      .then((r) => r.data)
      .catch(() => ({ enabled: false, nav_visible: false, is_founder: false }));
  }
  return cache[key];
}

export function usePortfolioFeature(userId) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let live = true;
    fetchPortfolioFeature(userId || "anon").then((d) => live && setState(d));
    return () => { live = false; };
  }, [userId]);
  return state;
}

export const errMsg = (e, fallback = "Something went wrong.") =>
  e?.response?.data?.detail ? formatApiError(e.response.data.detail) : fallback;

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const PHOTO_MAX = 50 * 1024 * 1024;
export const VIDEO_MAX = 500 * 1024 * 1024;
export const PHOTO_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"];
export const VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/webm", "video/x-m4v"];
export const ACCEPT = [...PHOTO_TYPES, ...VIDEO_TYPES, ".heic", ".heif", ".mov", ".m4v"].join(",");

export function clientValidate(file) {
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  const isPhoto = PHOTO_TYPES.includes(file.type) || ["jpg", "jpeg", "png", "webp", "heic", "heif"].includes(ext);
  const isVideo = VIDEO_TYPES.includes(file.type) || ["mp4", "mov", "m4v", "webm"].includes(ext);
  if (!isPhoto && !isVideo) return "Unsupported file type. Use JPEG, PNG, WebP, HEIC, MP4, MOV, M4V or WebM.";
  if (isPhoto && file.size > PHOTO_MAX) return "Photos must be 50 MB or smaller.";
  if (isVideo && file.size > VIDEO_MAX) return "Videos must be 500 MB or smaller.";
  return null;
}

export const STATUS_FILTERS = [
  { key: "", label: "All" },
  { key: "draft", label: "Draft" },
  { key: "in_review", label: "In review" },
  { key: "approved", label: "Approved" },
  { key: "published", label: "Published" },
  { key: "unpublished", label: "Unpublished" },
  { key: "archived", label: "Archived" },
];
